import React from 'react'
import Seo from 'src/components/seo'
import styled from '@emotion/styled'
import { breakpoints, colors, fonts, fontSizes } from 'src/utils/styles'
import bg from 'src/static/images/ll_banner_newsletter_desktop.jpg'
import bg_mobile from 'src/static/images/ll_banner_newsletter_mobile.jpg'
import { PageLayout } from 'src/layouts/styles'
import { useNavigation } from 'src/hooks/useNavigation'
import { useTranslation } from 'react-i18next'
import { graphql } from 'gatsby'
import NewsLetterForm from '../components/NewsLetterForm'

const TwoColumnGrid = styled.div`
  display: flex;
  @media (max-width: ${breakpoints.xl}px) {
    flex-direction: column;
    margin-left: 0;
  }
`

const GridLeft = styled.div`
  grid-area: left;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  max-width: 750px;
  width: 100%;
`

const GridRight = styled.div`
  grid-area: right;
  display: flex;
  max-width: 627px;
  flex-direction: column;
  align-content: space-between;
  margin-left: 2em;

  @media (max-width: ${breakpoints.l}px) {
    margin-left: 0;
    margin-top: 4em;
  }
`

const Benefits = styled.div`
  display: flex;
  flex-direction: column;
`

const StHeadline = styled.h1`
  font-family: ${fonts.extendedBold};
  font-size: ${fontSizes.headline};
  margin-top: 0;
  margin-bottom: 2em;

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.headlineMobile};
  }
`

const InnerFormWrapper = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem 3rem 3rem 6rem;

  @media (max-width: ${breakpoints.xxl}px) {
    margin: 3rem 3rem 3rem 3rem;
  }
  @media (max-width: ${breakpoints.l}px) {
    margin: 2em 0 0;
  }
`
const StWrapper = styled.div`
  margin: 1.25em 6em 0;
  overflow-wrap: break-word;
  font-family: ${fonts.regular};
  color: ${colors.darkGray};

  @media (max-width: ${breakpoints.s}px) {
    margin: 0 1.5em 2em;
  }
`

const StText = styled.p`
  font-family: ${fonts.regular};
  font-size: ${fontSizes.text};

  a {
    text-decoration: underline;
    color: ${colors.darkGray};
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.textMobile};
  }
`

const StSubHeadline = styled.span`
  font-family: ${fonts.bold};
  color: ${colors.darkGray};
  margin: 1.25em 0 0;
  font-size: ${fontSizes.subHeadline};

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.textMobile};
  }
`

const StImg = styled.img`
  width: 100%;
  height: auto;

  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`
const StImgMobile = styled(StImg)`
  display: none;
  @media (max-width: ${breakpoints.s}px) {
    display: unset;
  }
`
const ImageWrapper = styled.div`
  @media (max-width: ${breakpoints.s}px) {
    margin-left: calc(50% - 50vw);
    margin-right: calc(50% - 50vw);
    max-width: 1000%;
    width: auto;
  }
`

const NewsletterPage = () => {
  const { t } = useTranslation('newsletter')
  const { SidebarNavigation } = useNavigation(false, <></>, <></>)

  return (
    <>
      <PageLayout>
        <Seo
          title={t('newsletter.headline')}
          keywords={[`lobster`, `lemonade`, `products`, `fashion`, `headwear`]}
        />
        {SidebarNavigation}

        <StWrapper>
          <StHeadline>{t('newsletter.headline')}</StHeadline>

          <TwoColumnGrid>
            <GridLeft>
              <InnerFormWrapper>
                <ImageWrapper>
                  <StImg src={bg} alt={'socks'} />
                  <StImgMobile src={bg_mobile} alt={'socks'} />
                </ImageWrapper>
                <InnerWrapper>
                  <NewsLetterForm />
                </InnerWrapper>
              </InnerFormWrapper>
            </GridLeft>

            <GridRight>
              <StText style={{ marginTop: 0, marginBottom: 0 }}>{t('newsletter.textPart1')}</StText>
              <Benefits>
                <StSubHeadline>{t('newsletter.benefit1')}</StSubHeadline>
                <StSubHeadline>{t('newsletter.benefit2')}</StSubHeadline>
                <StSubHeadline>{t('newsletter.benefit3')}</StSubHeadline>
              </Benefits>
              <StText style={{ marginTop: '2em' }}>{t('newsletter.textPart2')}</StText>
            </GridRight>
          </TwoColumnGrid>
        </StWrapper>
      </PageLayout>
    </>
  )
}

export default NewsletterPage

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: {
        ns: { in: ["newsletter", "misc", "footer", "lineItem", "shoppingCart", "cookies"] }
        language: { eq: $language }
      }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
